import { Button } from "common/components/ui/Button";
import { DialogFooter, DialogHeader } from "common/components/ui/Dialog";
import { DrawerFooter, DrawerHeader } from "common/components/ui/Drawer";
import useLicenseMutations from "common/datahooks/useLicenseMutations";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

interface RemoveLicenseProps {
  accountId: string;
  accountFullname: string;
  goBack: () => void;
  onSuccess: () => void;
}

export default function RemoveLicense({
  accountId,
  accountFullname,
  goBack,
  onSuccess,
}: RemoveLicenseProps) {
  const isDesktop = useTwBreakpoint("lg");

  const { removeLicense, isRemovingLicense } = useLicenseMutations();

  function onRemove() {
    removeLicense({ accountId }).then(onSuccess);
  }
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <>
      <Header
        title={<>Unassign seat from "{accountFullname}"?</>}
        subtitle="This will stop all campaigns on this LinkedIn account. You can re-assign this seat at any time"
      />

      <Footer className="justify-end">
        <Button
          onClick={goBack}
          variant="secondary-black"
          disabled={isRemovingLicense}
        >
          Cancel
        </Button>
        <Button
          isLoading={isRemovingLicense}
          onClick={onRemove}
          variant="outline-danger"
        >
          Unassign
        </Button>
      </Footer>
    </>
  );
}
